export default {
  autoHeight: {
    height: 'auto',
    paddingTop: 'env(safe-area-inset-top)'
  }
};
